import { Box, Button, Link, Paper, Typography } from '@mui/material';
import { HourglassEmpty } from '@mui/icons-material';
import { useAuth } from '../../auth/useAuth';

export const PendingAccessPage = () => {
  const { logout } = useAuth();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f0',
      }}
    >
      <Paper
        elevation={2}
        sx={{
          p: 5,
          maxWidth: 440,
          width: '100%',
          textAlign: 'center',
          borderRadius: '12px',
        }}
      >
        <HourglassEmpty sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
          Access Pending
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Your access request is being reviewed.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Please contact Vahid Haeri directly if you need access:
          <br />
          <Link href="mailto:vhaeri@bgcengineering.ca" underline="hover">
            vhaeri@bgcengineering.ca
          </Link>
        </Typography>
        <Button
          variant="outlined"
          onClick={() => logout()}
          sx={{ textTransform: 'none' }}
        >
          Sign Out
        </Button>
      </Paper>
    </Box>
  );
};
